import Code from "../../../components/code";
import DocsAuthor from "../../components/docsAuthor";

export const scriptManagementPage = {
    title: "Script Management",
    sections: [
        {
            id: "flush",
            name: "Flush Scripts",
        },
        {
            id: "devScript",
            name: "Development Script",
        },
    ],
    content: (
        <>
        <DocsAuthor nickname="StrayVibes" publishedAt="June 1, 2025 at 11:20 AM" />
            <section id="flush">
                <h2>🌊 Flush Scripts - Clear the Way!</h2>
                <p>
                    Ready to give your scripts a fresh start? Use the powerful cats framework to run your scripts with a clean slate! Just type: <Code fullWidth>meow flush</Code>
                    It's like a refreshing wave for your codebase! 🏄‍♀️
                </p>
            </section>
            <section id="devScript">
                <h2>👨‍💻 Development Script - Build and Innovate!</h2>
                <p>
                    Ignite your development workflow! 🚀 Execute your project's development script with ease. This command is your go-to for bringing your ideas to life: <Code fullWidth>meow dev</Code>
                    Get ready to code! ✨
                </p>
            </section>
        </>
    ),
};
